import React from "react";
import './gr-icons-list.scss';


export default class GrIconsListComponent extends React.Component {

    render(){
        return (
            <div className="icons-wrap">
            {this.props.icoArr.map((value, index) => 
                <div className="ico" key={index}>
                    <img src={value} alt="#" />
                </div>
            )}
        </div>
        );
    }
}